import { Injectable } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

type ImageCache = {
  status: string;
  url?: SafeResourceUrl;
};

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  public imageCache: Record<string, ImageCache> = {};
}
